import { apiClient } from './client';
import type { ApiResponse } from '../types/api';

export interface SpreadType {
  id: number;
  spreadKey: string;
  nameTh: string;
  nameEn: string;
  descriptionTh: string;
  cardCount: number;
  positions: { id: number; name: string; description: string; x: number; y: number }[];
  layoutConfig: any;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  requiredTier: string;
  requiresPurchase: boolean;
  coinCost: number | null;
  sortOrder: number;
  metadata: any;
  isAccessible: boolean;
  isPurchased: boolean | null;
  purchaseItem?: {
    itemId: number;
    itemName: string;
    description: string;
    priceCoins: number;
    iconUrl: string | null;
  } | null;
}

export interface SpreadsListResponse {
  spreads: SpreadType[];
  total: number;
}

export const spreadsAPI = {
  getSpreads: () =>
    apiClient.get<any, ApiResponse<SpreadsListResponse>>('/api/spreads'),

  getSpread: (key: string) =>
    apiClient.get<any, ApiResponse<{ spread: SpreadType }>>(`/api/spreads/${key}`),
};
